if (typeof window.ModalDialog === 'undefined') {
  window.ModalDialog = class ModalDialog extends HTMLElement {
    constructor() {
      super();
      const closeButton = this.querySelector('[id^="ModalClose-"]');
      if (closeButton) closeButton.addEventListener('click', () => this.hide());
      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.hide();
      });
    }

    connectedCallback() {
      if (!this.moved) {
        this.moved = true;
        document.body.appendChild(this);
      }
    }

    show(opener) {
      this.openedBy = opener;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      const dialog = this.querySelector('[role="dialog"]');
      if (dialog) dialog.focus();
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      if (this.openedBy && this.openedBy.focus) this.openedBy.focus();
    }
  };
}
